import { render, staticRenderFns } from "./CategoryMegaMenu.vue?vue&type=template&id=1bdf856b&scoped=true"
import script from "./CategoryMegaMenu.vue?vue&type=script&lang=js"
export * from "./CategoryMegaMenu.vue?vue&type=script&lang=js"
import style0 from "./CategoryMegaMenu.vue?vue&type=style&index=0&id=1bdf856b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf856b",
  null
  
)

export default component.exports